import {
  TextInput,
  SelectInput,
  ReferenceInput,
  Create,
  SimpleForm,
  required,
} from "react-admin";

import { CustomToolbar } from "../../../utils";

const validateRequired = required();

const SampleCreate = (props) => (
  <Create redirect="list" title="Nova Amostra" {...props}>
    <SimpleForm toolbar={<CustomToolbar />}>
      <TextInput
        label="Nome"
        source="name"
        validate={validateRequired}
        resettable
      />
      <TextInput
        label="Descrição"
        source="description"
        validate={validateRequired}
        resettable
      />
      <TextInput
        placeholder="ex: https://rxpro.com.br"
        label="URL"
        source="url"
        validate={validateRequired}
        resettable
      />
      <TextInput
        label="Código da Amostra"
        source="sample_id"
        defaultValue={null}
        resettable
      />
      <ReferenceInput
        sort={{ field: "name", order: "ASC" }}
        perPage={999}
        resource="lab"
        label="Laboratório"
        source="labId"
        reference="labs"
      >

        <SelectInput optionText="name" optionValue="id" />
      </ReferenceInput>
    </SimpleForm>
  </Create>
);

export default SampleCreate;
